import { trackChecklistEvent } from "./buyerAnalytics";

export function trackBuyerChecklistEvent(eventType, metadata = {}) {
  trackChecklistEvent(eventType, metadata);
}
